import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

// import useChecklist from '../hooks/useChecklist';

import { PoliciesContext } from '../hooks/policiesContext';
import useAuth from '../hooks/useAuth';
import useAlert from '../hooks/useAlert';
import api from '../app/api';
import Loader from './Loader';
import { keys } from '../config/keys';

const FormCard = ({ data }) => {
    const state = useContext(PoliciesContext);
    const { addForShare } = state;
    const { isAdmin, isCompany } = useAuth()
    const [loading, setLoading] = useState(false)
    const total = data?.questions?.length
    const { showAlert } = useAlert()
    const handleShare = async () => {
        setLoading(true)
        try {
            const response = await api.post("/share/add", {
                allowedEmails: [],
                shareable: [data],
                forFeature: "form",
                createdBy: localStorage.getItem("_id"),
                isCopyLink:true
            });
            if (response.data?.status) {
                copyFormLink(response.data.result?._id)
            } else {
                showAlert(response.data?.message, "danger");
            }
        } catch (error) {
            showAlert(error?.message, "danger");
        } finally {
            setLoading(false)
        }
    };
    const copyFormLink = async (id) => {
        try {
            const origin = window.location.origin || keys.CLIENT_ORIGIN;
            const link = `${origin}/form-submission?id=${id}&allowed=all`;
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(link);
            } else {
                const input = document.createElement("textarea");
                input.value = link;
                input.setAttribute("readonly", "");
                input.style.position = "fixed";
                input.style.left = "-9999px";
                document.body.appendChild(input);
                input.select();
                document.execCommand("copy");
                document.body.removeChild(input);
            }
            showAlert("Link copied to clipboard", "success");
        } catch (error) {
            showAlert(error?.message || "Unable to copy link", "danger");
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className="col-lg-4 col-md-6 col-sm-6 d-flex align-items-stretch aos-init aos-animate" data-aos="zoom-in"
            data-aos-delay="200">
            <div className="icon-box">
                <p className='d-flex w-100 justify-content-center text-info'>{
                    isAdmin || isCompany ? data.addedBy?.name :
                        null
                }</p>

                <div className="icon"><i className="bi bi-card-checklist"></i></div>

                <h4 className="title">{data?.title}</h4>
                <p className="description mb-4">
                    {total} &nbsp;
                    {'Questions'} {'Added'}
                </p>
                <Link
                    className='mb-2'
                    onClick={() => handleShare(data)}
                    state={{
                        selectedForShare: [data],
                        isForm: true
                    }}
                >
                    <Loader loading={loading} color={'blue'}>
                        {'Copy Link'}
                    </Loader>
                </Link>
                <Link
                    className='mb-2'
                    to={'/share'}
                    onClick={() => addForShare(data)}
                    state={{
                        selectedForShare: [data],
                        isForm: true
                    }}
                >
                    {'Share Form'}
                </Link>
                <Link
                    to={'/add-form'}
                    state={data}
                >
                    {'View Form'}
                </Link>


            </div>
        </div>
    )
}

export default FormCard;